var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenFan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 10.6663C9.47341 10.6663 10.6673 9.47243 10.6673 7.99967C10.6673 6.52692 9.47341 5.33301 8.00065 5.33301C6.52789 5.33301 5.33398 6.52692 5.33398 7.99967C5.33398 9.47243 6.52789 10.6663 8.00065 10.6663Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5173 7.12009C12.1944 5.96384 13.9019 6.66634 14.3357 6.66634C14.6893 6.66634 15.0284 6.52586 15.2785 6.27582C15.5285 6.02577 15.669 5.68663 15.669 5.33301C15.669 3.10676 13.5807 0.333008 11.3357 0.333008C9.03732 0.333008 8.2444 2.89051 8.05273 5.33551",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88086 10.5144C10.0371 12.1915 9.33461 13.899 9.33461 14.3327C9.33461 14.6863 9.47509 15.0255 9.72513 15.2755C9.97518 15.5256 10.3143 15.6661 10.6679 15.6661C12.8942 15.6661 15.6679 13.5777 15.6679 11.3327C15.6679 9.03439 13.1104 8.24147 10.6654 8.0498",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12107 5.48467C5.96482 3.80759 6.66732 2.10009 6.66732 1.66634C6.66732 1.31272 6.52684 0.973581 6.27679 0.723532C6.02674 0.473484 5.68761 0.333008 5.33398 0.333008C3.10773 0.333008 0.333984 2.42134 0.333984 4.66634C0.333984 6.96467 2.89148 7.75759 5.33648 7.94926",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48565 8.87891C3.80857 10.0352 2.10107 9.33266 1.66732 9.33266C1.3137 9.33266 0.974557 9.47313 0.724509 9.72318C0.47446 9.97323 0.333984 10.3124 0.333984 10.666C0.333984 12.8922 2.42232 15.666 4.66732 15.666C6.96565 15.666 7.75857 13.1085 7.95023 10.6635",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33529 8C9.33529 8.35362 9.19481 8.69276 8.94476 8.94281C8.69471 9.19286 8.35558 9.33333 8.00195 9.33333",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFan);
export default __webpack_public_path__ + "static/media/openFan.9a70e1de.svg";
export { ForwardRef as ReactComponent };